import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { Typography } from "@mui/material";

import { BrandContext } from "../../App";
import LandingLayout from "../Layout/Layout";

import { CheckAuth } from "../../utils";

import ScrollToTop from "../helpers/ScrollToTop";

import { useUI } from "../../contexts/UIContext";

export default function Account() {
  const { brand } = useContext(BrandContext);
  const { showFooter, theme } = useUI();

  return (
    <>
      <ScrollToTop />
      <CheckAuth />
      <LandingLayout>
        <div className="app-inner-container">
          <Outlet />
          {showFooter && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mt: theme.containers.paddingDesktop,
                width: "100%",
                bottom: 5,
                textAlign: "center",
              }}
            >
              {"© "}
              {brand.name} {new Date().getFullYear()}
            </Typography>
          )}
        </div>
      </LandingLayout>
    </>
  );
}
